export default __webpack_public_path__ + "static/media/comfortable-msk.5da04cca.png";